// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3ZDtl","productName":"Table_productName__cPKHj"};